module.exports = __webpack_public_path__ + "front/img/main-img-1.557f2566.png";